import { cn, Icon, IconTile } from "@iec-id/ui";
import type { ReactNode } from "react";

export interface RewardCalloutProps {
	/** Крупная строка: «+500 Баллов» или «700 Баллов при регистрации». */
	title: ReactNode;
	/** Пояснение под ней. Может содержать подсказку-тултип. */
	caption?: ReactNode;
	/** Роль крупной строки: `points` — моно 20px, `lead` — проза 16px. */
	tone?: "points" | "lead";
	className?: string;
}

/**
 * Зелёная плашка с подарком (макеты 4b-5 и 4c). Заливка — `--p-green-16`,
 * единственный случай, когда бренд работает подложкой: это не декор, а
 * сообщение «вам начислено».
 *
 * Плитка иконки белая, потому что стоит на цветной подложке — правило IconTile:
 * заливка выбирается от фона, а не от смысла.
 */
export function RewardCallout({ title, caption, tone = "points", className }: RewardCalloutProps) {
	return (
		// `items-start`, а не по центру: подпись бывает в две-три строки, и
		// плитка тогда уезжала в середину блока. Прижатая к верху, она стоит на
		// одном отступе с левым краем (p-4) и держит первую строку.
		<div className={cn("flex items-start gap-3.5 rounded-control bg-brand-soft p-4", className)}>
			<IconTile tone="card" size={40}>
				<Icon name="Gift" size={20} />
			</IconTile>
			<div className="flex min-w-0 flex-col gap-0.5">
				<span
					className={
						tone === "points"
							? // Моно 20px из макета 4b-5. Роль теперь есть в токенах
								// (`--t-num-md-s`) — ручной набор был временным (В6 аудита).
								"t-num-md-s tabular-nums text-fg"
							: "t-row text-fg"
					}
				>
					{title}
				</span>
				{caption ? <span className="t-meta text-fg-secondary">{caption}</span> : null}
			</div>
		</div>
	);
}
